module.exports = "<h6 class=\"title\">Kan je niet vinden wat je zoekt?</h6>\r\n<p>We hebben ook standaard templates in de volgende categorieën:<a href=\"#\">bedrijven</a>, <a href=\"#\">evenementen</a>, <a href=\"#\">beauty en welness</a>, <a href=\"#\">fotografie</a>, <a href=\"#\">portfolio's en CV's</a>, <a href=\"#\">persoonlijk</a>, <a href=\"#\">muziek</a>, <a href=\"#\">winkels</a>.</p>"


//////////////////
// WEBPACK FOOTER
// ./src/locales/nl-NL/more-templates.html
// module id = 536
// module chunks = 2